/* eslint-disable @typescript-eslint/no-explicit-any */
import { AutomationServer } from "@medapro-types/AutomationServer/AutomationServer";
//import { MeDaProProjectFileType } from "@medapro-types/AutomationServer/AutomationServer.enums";
import api from "./api";
import endpoints from "./endpoints";

export default {
  getAutomation: async function (args: any) {
    const response = await api.get(endpoints.automationServer.get, { params: args });
    return response.data;
  },
  getAllAutomations: async function (args: any) {
    const response = await api.get(endpoints.automationServer.getAll, { params: args });
    return response.data;
  },
  getAllAutomationTemplates: async function (args: any) {
    const response = await api.get(endpoints.automationServer.getAllTemplates, { params: args });
    return response.data;
  },
  createOrUpdateAutomation: async function (args: any) {
    const response = await api.post(endpoints.automationServer.update, args);
    return response.data;
  },
  getActionTypes: async function () {
    const response = await api.get(endpoints.automationServer.getActionTypes, {});
    return response.data;
  },
  deleteAutomation: async function (args: any) {
    const response = await api.post(endpoints.automationServer.delete, args);
    return response.data;
  },
  executeAutomation: async function (automationIds: Array<string>, checkConditions: boolean) {
    const response = await api.post(endpoints.automationServer.execute, automationIds, { params: { checkConditions } });
    return response.data;
  },
  activateOrDeactivateAutomation: async function (automationIds: Array<string>, activate: boolean) {
    const response = await api.post(endpoints.automationServer.activateOrDeactivate, automationIds, { params: { activate } });
    return response.data;
  },
  getTriggerTypes: async function () {
    const response = await api.get(endpoints.automationServer.getTriggerTypes, {});
    return response.data;
  },
  getProjectFiles: async function (projectFileType: AutomationServer.MeDaProProjectFileType | string): Promise<Array<string>> {
    const response = await api.get(endpoints.automationServer.getProjectFiles, { params: { projectFileType } });
    return response.data;
  },
  getPowershellFiles: async function (): Promise<Array<string>> {
    const response = await api.get(endpoints.automationServer.getPowershellFiles);
    return response.data;
  },
  executeAutomationsIfRequired: async function (triggerTypes: Array<AutomationServer.TriggerType>) {
    const response = await api.post(endpoints.automationServer.executeAutomationsIfRequired, triggerTypes);
    return response.data;
  },
  getAutomationRun: async function (automationRunId: string) {
    const response = await api.get(endpoints.automationServer.getAutomationRun, { params: { automationRunId } });
    return response.data;
  },
  getActionsOnAutomation: async function (automationRunId: string) {
    const response = await api.get(endpoints.automationServer.getActionsOnAutomation, { params: { automationRunId } });
    return response.data;
  },
  getExports: async function (targetType: string, language: string) {
    const response = await api.get(endpoints.exports.getExports, { params: { targetSystem: targetType, language } });
    return response.data;
  },
  getImports: async function (targetType: string) {
    const response = await api.get(endpoints.import.getAll, { params: { type: targetType } });
    return response.data;
  }
};
